<div class="rule-group-box" [class.rule-group-nested]="depth > 0">
    <div class="flex align-items-center gap-2 mb-2">
        <span class="text-500 text-sm">Rules logic:</span>
        <p-dropdown [options]="combinatorOptions" [(ngModel)]="group.combinator" optionLabel="label"
            optionValue="value" [appendTo]="'body'" styleClass="ss-rule-combinator"></p-dropdown>
    </div>

    <div class="flex flex-column gap-2">
        <ng-container *ngFor="let child of group.children; let i = index">
            <div class="flex align-items-center gap-2">
                <p-dropdown [options]="operatorOptions" [(ngModel)]="asCondition(child).operator" optionLabel="label"
                    optionValue="value" [appendTo]="'body'" styleClass="ss-rule-operator"></p-dropdown>
                <input *ngIf="needsValue(child)" pInputText class="w-full" [(ngModel)]="asCondition(child).value"
                    placeholder="Digite a URL da página">
                <button pButton icon="pi pi-trash" class="p-button-text p-button-rounded p-button-danger"
                    (click)="removeChild(i)"></button>
            </div>
        </ng-container>
    </div>

    <div class="flex gap-2 mt-2">
        <button pButton label="Adicionar regra" icon="pi pi-plus" class="p-button-text p-button-sm"
            (click)="addCondition()"></button>
    </div>
</div>
